import { render, staticRenderFns } from "./AddRate.vue?vue&type=template&id=7e04ac00&"
import script from "./AddRate.vue?vue&type=script&lang=ts&"
export * from "./AddRate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports